import { createReducer, on } from "@ngrx/store";
import { StreamAction } from "./stream.actions";

export interface StreamState {
    token?: string;
    loading: boolean;
    error?: string;
    initiated: boolean;
}

export const INITIAL_STREAM_STATE: StreamState = {
    token: null,
    loading: false,
    error: null,
    initiated: false,
}

export const streamReducer = _streamReducerFactory(window);

export function _streamReducerFactory(_window) {
  return createReducer(
    INITIAL_STREAM_STATE,
    on(StreamAction.requestStreamToken, (state) => ({ ...state, loading: true })),
    on(StreamAction.responseSuccessStreamToken, (state, { token }) => ({ ...state, token, loading: false })),
    on(StreamAction.responseFailStreamToken, (state, { error }) => ({ ...state, error, loading: false })),

    on(StreamAction.requestInitStream, (state) => ({ ...state, loading: true })),
    on(StreamAction.responseSuccessInitStream, (state) => ({ ...state, loading: false, initiated: true })),
    on(StreamAction.responseFailInitStream, (state, { error }) => ({ ...state, error, loading: false, initiated: false })),
  );
}

